export type ChatPageScrollEdge = 'start' | 'end';

/** `start` — начало страницы (верх), `end` — конец (низ). Учитывает `column-reverse`. */
export function getScrollTopForEdge(el: HTMLElement, edge: ChatPageScrollEdge): number {
    const maxDistance = Math.max(0, el.scrollHeight - el.clientHeight);
    const reversed = getComputedStyle(el).flexDirection.includes('reverse');

    if (!reversed) {
        return edge === 'start' ? 0 : maxDistance;
    }

    if (edge === 'end') {
        return 0;
    }

    return -maxDistance;
}

export function findVerticalScrollParent(el: HTMLElement): HTMLElement | null {
    let current: HTMLElement | null = el.parentElement;

    while (current) {
        const overflowY = getComputedStyle(current).overflowY;

        if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
            return current;
        }

        current = current.parentElement;
    }

    return null;
}
